import { Inject, Injectable, OnDestroy, Optional } from '@angular/core';
import { CacheStoragesEnum, ICacheLogger, I_CACHE_LOGGER } from '../models/cache.models';
import { CacheStorageBase } from './base/cache-storage-base.service';
import { SerializeHelper } from './serialize.helper';

@Injectable()
export class CacheStorageSession extends CacheStorageBase implements OnDestroy {
  public constructor(@Optional() @Inject(I_CACHE_LOGGER) private readonly logger?: ICacheLogger) {
    super();
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  public ngOnDestroy(): void {}

  public getItem<TItem>(key: string, force: boolean = false) {
    if (!this.isEnabled() && !force) {
      return null;
    }
    const value = sessionStorage.getItem(key);
    if (!value) {
      return null;
    }
    try {
      return SerializeHelper.deserialize<TItem>(value);
    } catch {
      this.logger?.error(`Cache entry could not be read and was evicted: ${key}`);
      this.removeItem(key);
      return null;
    }
  }

  public setItem<TItem>(key: string, value: TItem): number | false {
    if (!this.isEnabled()) {
      return false;
    }
    try {
      const item = value ? SerializeHelper.serialize(value) : '';
      sessionStorage.setItem(key, item);
      return item.length;
    } catch (e) {
      this.isEnabled(true);
      return false;
    }
  }

  public removeItem(key: string) {
    try {
      sessionStorage.removeItem(key);
    } catch {}
  }

  public type() {
    return CacheStoragesEnum.SESSION_STORAGE;
  }

  public isEnabled(check?: boolean): boolean {
    if (check) {
      this.isEnabledValue = undefined;
    }
    const currentDate = new Date();
    if (this.isEnabledValue === undefined || this.isEnabledValueTimestamp < currentDate) {
      try {
        sessionStorage.setItem('test', 'test');
        sessionStorage.removeItem('test');
        this.isEnabledValue = true;
      } catch (e) {
        this.isEnabledValue = false;
      }
      this.isEnabledValueTimestamp = new Date(currentDate.getTime() + this.isEnabledValueTimeout);
    }
    return this.isEnabledValue;
  }

  public length(): number {
    return sessionStorage.length;
  }

  public key(index: number): string {
    return sessionStorage.key(index);
  }

  public persist(): void {}

  public unPersist(prefix: string): void {
    this.clear(prefix);
  }
}
